/**
 * Routes
 */
export const DASHBOARD_ROUTES = {
  index: {
    path: 'app/*',
    to: '/app/dashboard',
  },
  home: {
    path: 'home',
    to: '/app/home',
  },
  profile: {
    path: 'profile/*',
    to: '/app/profile',
  },
  profileChangePassword: {
    path: 'change-password',
    to: '/app/profile/change-password',
  },
  dashboard: {
    path: 'dashboard/*',
    to: '/app/dashboard',
  },
  overdueDashboard: {
    path: 'overdueDashboard/*',
    to: '/app/overdueDashboard',
  },
  bulkUpload: {
    path: 'bulk-upload/*',
    to: '/app/bulk-upload',
  },
  addUser: {
    path: 'add-user',
    to: '/app/profile/add-user',
  },
  addAdmin: {
    path: 'add-partner',
    to: '/app/profile/add-partner',
  },
  feesDashboard: {
    path: 'fees-dashboard/*',
    to: '/app/fees-dashboard',
  },
};
